import React from "react";

import styles from "../../../../styles/integrations.module.scss";

import { Loading } from "../../../components/Loading";
import { Drawer } from "../../../components/Drawer";
import { Button } from "../../../components/Button";
import { Context } from "pages/Integrations";
import { Select } from "@components";

export default class AtenaAICheckoutDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: false,
      loading: false,
      checkoutId: null,
    };
  }

  componentDidMount() {
    if (this.props.checkoutId) {
      this.setState({ checkoutId: this.props.checkoutId });
    }
  }

  componentDidUpdate({ checkoutId }) {
    if (this.props.checkoutId && this.props.checkoutId !== checkoutId) {
      this.setState({ checkoutId: this.props.checkoutId });
    }
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { checkoutId } = this.state;

      this.setState({ loading: true });

      await onSave(checkoutId);

      this.setState({ loading: false });
    } catch (e) {
      alert({
        text: `Não foi possível alterar a configuração: ${e.message}`,
      });

      this.setState({ loading: false });
    }
  }

  buildSelectOptions(options, selectedValue) {
    const builtOptions = options.map((option) => ({
      label: option.name,
      value: option.id,
      selected: option.id === selectedValue,
    }));

    return [
      {
        label: "Selecione",
        value: "",
        selected: !selectedValue,
      },
      ...builtOptions,
    ];
  }

  render() {
    const {
      loading,
      loadingPage,
      checkoutId,
    } = this.state;
    const { visible, checkouts, onClose } = this.props;

    const isValid = checkoutId;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        alreadyDrawer
        title={"Atena.ai - Caixa"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading || !isValid}
          >
            Confirmar
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Select
              design="two"
              label="Caixa"
              onChange={(e) => this.setState({ checkoutId: e.target.value })}
              className="mt-20"
              value={checkoutId}
              options={this.buildSelectOptions(checkouts, checkoutId)}
            />
          </div>
        )}
      </Drawer>
    );
  }
}
